import {Component, OnDestroy, OnInit} from '@angular/core';
import {DialogRef} from '@progress/kendo-angular-dialog';
import {ImportacaoEntreLojasService} from '../../services/importacao-entre-lojas.service';
import {FluxoImportacaoEntreLojas} from './fluxo-importacao-entre-lojas';

@Component({
  selector: 'app-importacao-entre-lojas',
  templateUrl: './importacao-entre-lojas.component.html',
  styleUrls: ['./importacao-entre-lojas.component.scss']
})
export class ImportacaoEntreLojasComponent extends FluxoImportacaoEntreLojas implements OnInit, OnDestroy {
  window: DialogRef;
  empresa: any;
  detalhesAbertos = false;
  readonly nomesCadastros: {[tipo: string]: string} = {
    produto: 'Produtos', categoria: 'Categorias', disponibilidade: 'Disponibilidades',
    template: 'Templates', 'template-tamanho': 'Tamanhos', 'template-adicional': 'Adicionais de template',
    'template-opcao': 'Opções de template', adicional: 'Adicionais', opcao: 'Opções',
    insumo: 'Insumos', 'ficha-tecnica': 'Fichas técnicas', 'grupo-insumo': 'Grupos de insumos',
    'apresentacao-compra': 'Unidades de compra', 'apresentacao-insumo': 'Vínculos de unidades de compra'
  };
  readonly iconesCadastros: {[tipo: string]: string} = {
    produto: 'fa-cube', categoria: 'fa-folder', disponibilidade: 'fa-clock',
    template: 'fa-layer-group', 'template-tamanho': 'fa-expand-arrows-alt', 'template-adicional': 'fa-list',
    'template-opcao': 'fa-list-ul', adicional: 'fa-list', opcao: 'fa-list-ul',
    insumo: 'fa-boxes', 'ficha-tecnica': 'fa-clipboard-list', 'grupo-insumo': 'fa-folder',
    'apresentacao-compra': 'fa-weight', 'apresentacao-insumo': 'fa-link'
  };
  readonly nomesResultados = {pendente: 'Aguardando', importando: 'Importando', importado: 'Importado', jaExiste: 'Já existe na loja', falhou: 'Falhou'};

  constructor(service: ImportacaoEntreLojasService) { super(service); }
  ngOnInit(): void { void this.carregueLojas(); }
  ngOnDestroy(): void { this.encerrado = true; }
  trackById(index: number, item: any): number { return item.idOrigem ?? item.id ?? index; }
  trackByResultado(index: number, item: any): number { return item.produto.idOrigem; }
  feche(): void {
    if(this.ocupado) return;
    this.window.close({importou: this.importados + this.existentes > 0});
  }
}
